export const PRIMARY_SLIDING_TAB_BUTTONS = 'PRIMARY_SLIDING_TAB_BUTTONS'
export const SECONDARY_SLIDING_TAB_BUTTONS = 'SECONDARY_SLIDING_TAB_BUTTONS'

export type SlidingTabButtonsKindsType = typeof PRIMARY_SLIDING_TAB_BUTTONS | typeof SECONDARY_SLIDING_TAB_BUTTONS

export const SMALL_SLIDING_TAB_BUTTONS = 'SMALL_SLIDING_TAB_BUTTONS'
export const MEDIUM_SLIDING_TAB_BUTTONS = 'MEDIUM_SLIDING_TAB_BUTTONS'

export type SlidingTabButtonsSizesType = typeof SMALL_SLIDING_TAB_BUTTONS | typeof MEDIUM_SLIDING_TAB_BUTTONS
